<h1 mat-dialog-title>Frag phito.</h1>
<div mat-dialog-content class="dialog-content">
    <div class="chat-wrapper">
        <phito-chat-window [conversation]="conversation()"></phito-chat-window>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button type="button" (click)="close()">Schließen</button>
    <button mat-flat-button type="button" (click)="newChat()">Neuer Chat</button>
</div>